import type { PropsWithChildren } from 'react';
import cx from 'classnames';

export const MobileContainer = ({ children }: PropsWithChildren) => {
  return (
    <nav id="drawer-nav" className={cx('z-50 lg:hidden')}>
      {children}
    </nav>
  );
};
